
export const CATALOG_PRODUCTS_TYPE = {
  NEWEST: 'newest',
  BESTSELLERS: 'bestsellers'
};
